<template>
  <v-container fluid>
    <v-row dense class="d-flex " style="height: 50px">
      <!-- View Title -->
      <v-col md="auto">
        <v-btn
          rounded
          small
          fab
          color="primary"
          class="add-button-fab mb-2"
          @click.stop="addSiteForm()"
        >
          <v-icon small>mdi-plus-thick</v-icon>
        </v-btn>
      </v-col>
      <v-col>
        <ViewTitle title="Empresas" />
      </v-col>
      <v-col
      class="d-flex justify-end mb-0 pb-0 component"
      md="auto"
      >
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn 
              v-bind="attrs"
              v-on="on"
              icon
              @click="select_import_site"
            >
              <v-icon>
                mdi-import
              </v-icon>
            </v-btn>
          </template>
          <span>Import centro</span>
        </v-tooltip>
        <SearchTextAdmin @input="setSearchText" 
        @output="setSearchText"/>
      </v-col>
    </v-row>
    <v-data-table
      fixed
      small
      :items="local_sites"
      :headers="fields"
      dense
      item-class="qmkey-item-row"
      show-expand
      :search="search"
    >
      <template v-slot:[`item.name`]="{ item }">
        <v-btn
          @click.stop="editSiteForm(item)"
          text
          small
          class="qmkey-add-button-menu"
        >
          {{ item.name }}
        </v-btn>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <!-- <v-btn
          small
          icon
          class="mr-2"
          @click.stop="editSiteForm(item.id)"
        >
         <v-icon >mdi-pencil</v-icon>
        </v-btn> -->
        <v-icon
          small
          class="mr-2"
          @click.stop="editSiteForm(item)"
        >
          mdi-pencil
        </v-icon>
        <v-icon
          small
          icon
          class="mr-2"
          @click="addSubSiteForm(item)"
        >
          mdi-plus
        </v-icon>
        <v-icon
          small
          icon
          class="mr-2"
          @click.stop="deleteSiteForm(item)"
        >
          mdi-trash-can-outline
        </v-icon>
        <InheritRoles 
          :disable="user.site === item.id"
          :sitePath="item.path"
          @refresh="refreshSites"
        ></InheritRoles>
        <v-icon
          small
          icon
          class="mr-2"
          @click.stop="addCentroForm(item)"
        >
          mdi-plus-circle-multiple-outline
        </v-icon>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-bind="attrs"
              v-on="on"
              small
              icon
              class="mr-2"
              @click.stop="exportSite(item)"
            >
              mdi-export
            </v-icon>
          </template>
          <span>Export centro</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <ExportSiteActions
              :site="item"
              @export-package="exportSite(item)"
              @export-excel="export_excel(item)"
              @advanced-export-excel="advanced_export_excel(item)"
            >
            </ExportSiteActions>
          </template>
          <span>Export Site options</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <ImportSiteActions
              :site="item"
              @import-package="select_import_site"
              @import-excel="select_import_excel"
              
            >
            </ImportSiteActions>
          </template>
          <span>Import Site options</span>
        </v-tooltip>
      </template>
      <!-- Expanded -->
      <template v-slot:expanded-item="{ item }">
        <td
          :colspan="fields.length +1"
          class="qmkey-explorer-table-expansion-td"
        > <!-- needed to use row length -->
          <v-container fluid>
            <v-row class="qmkey-explorer-table-expansion-cont">
              <v-tabs
                v-model="tabs"
                icons-and-text
                align-with-title
                background-color="#cac8c9"
                height = 32
                class="qmkey-explorer-table-expansion-panel"
                active-class="qmkey-explorer-table-expansion-panel-active"
              >
                <v-tabs-slider style="display: none"></v-tabs-slider>
                <v-tab class="qmkey-explorer-table-expansion-panel-header">
                  <div class="tab">Company</div>
                </v-tab>
                <v-tab class="qmkey-explorer-table-expansion-panel-header">
                  <div class="tab">Inherit Role</div>
                </v-tab>
                <v-tab class="qmkey-explorer-table-expansion-panel-header">
                  <div class="tab">Centros</div>
                </v-tab>
              </v-tabs>
              <v-tabs-items 
                v-model="tabs"
                class="qmkey-explorer-table-expansion-panel-contents"
              >
                <v-tab-item
                  class="qmkey-explorer-table-expansion-panel-content"
                >
                  <!-- Site data -->
                  <v-container fluid>
                    <v-row align="end" class="white data-inline-content">
                      <v-col cols="6">
                        <span class="data-inline-header-content-reference">
                          #{{ item.id }}
                        </span>
                        <span class="pl-1 data-inline-header-content-title">
                          {{ item.name }}
                        </span>
                      </v-col>
                    </v-row>
                      <span class="data-inline-expand-title"></span>
                      <v-row>
                        <v-col>
                          <div>
                            <span class="data-inline-data-title"> Name </span>
                            <div class="data-inline-data text-justify"
                                  v-html="item.name">                    
                            </div>
                          </div>
                        </v-col>
                        <v-col>
                          <div>
                            <span class="data-inline-data-title"> QMKey product </span>
                            <div class="data-inline-data text-justify" 
                                  v-html="qmkey_product.filter((value)=>value.value==item.qmkey_product)[0].text">                    
                            </div>
                          </div>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <div>
                            <span class="data-inline-data-title"> Max. users </span>
                            <div class="data-inline-data text-justify" 
                                  v-html="item.max_users_number">                    
                            </div>
                          </div>
                        </v-col>
                        <v-col>
                          <div>
                            <span class="data-inline-data-title"> Storage type </span>
                            <div class="data-inline-data text-justify" 
                                  v-html="storage_types.filter((value) => value.value == item.storage_type)[0].text">                    
                            </div>
                          </div>
                        </v-col>
                        <v-col><!-- This is a column space for better dispaly --></v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <div>
                            <span class="data-inline-data-title"> Logo </span>
                            <div class="data-inline-data text-justify">
                              <v-img
                                max-width="100px"
                                :src="getLogo(item)"
                                contain
                              />
                            </div>
                          </div>
                        </v-col>
                        <v-col>
                          <div>
                            <span class="data-inline-data-title"> Process map </span>
                            <div class="data-inline-data text-justify">
                              <v-img
                                  max-width="100px"
                                  :src="getProcessMap(item)"
                                  contain
                                />
                            </div>
                          </div>
                        </v-col>
                        <v-col>
                          <span class="data-inline-data-title"> Fondo corporativo </span>
                            <div class="data-inline-data text-justify">
                              <v-img
                                  max-width="200px"
                                  :src="getBackgroundImage(item)"
                                  contain
                                />
                            </div>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <span class="data-inline-data-title"> Pie de página informes/listados</span>
                            <div class="qfieldstringarea-text">
                              <div class="dqfieldstringarea-text" 
                                  v-html="item.reports_footer_text">                    
                              </div>
                            </div>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <span class="data-inline-data-title"> Permitir cambio de contraseña</span>
                            <div class="data-inline-data text-justify">
                              <div class="data-inline-data text-justify" >
                                  {{ item.allow_password_change? 'Sí' : 'No' }}
                              </div>
                            </div>
                        </v-col>
                      </v-row>
                  </v-container>
                </v-tab-item>
                <v-tab-item
                  class="qmkey-explorer-table-expansion-panel-content"
                >
                  <!-- Site inherit roles -->
                  <v-container fluid>
                    <div class="qmkey-related-inline-table">
                      <v-data-table
                        :items="getInheritRoles(item.inherit_roles)"
                        :headers="roleFields"
                        dense
                        item-class="qmkey-item-row"
                        sortBy="parent_name"
                      >
                      </v-data-table>
                    </div>
                  </v-container>
                </v-tab-item>
                <!-- CENTROS -->
                <v-tab-item
                  class="qmkey-explorer-table-expansion-panel-content"
                >
                  <!-- Site centros -->
                  <v-container fluid>
                    <SiteCentros 
                      :site="item"
                      @update="update_centeros"
                    />
                  </v-container>
                </v-tab-item>
              </v-tabs-items>
            </v-row>
          </v-container>
        </td>
      </template>

    </v-data-table>
    <!-- Add /edit dialog && delete site-->
    <modal-dialog-form
      :title="modal_title"
      :showModalDialog="showModalDialog"
      :fields_to_collect="fields_to_collect"
      :submit_button_text="submit_button_caption"
      validate
      @close-dialog="toggle_dialog"
      @submit="submit_action"
    >
    </modal-dialog-form>
    <v-dialog v-if="showExcelImportDialog"
      v-model="showExcelImportDialog"
      @keydown.esc="close_excel_import_dialog"
      persistent
    >
      <div
        class="modal-card"
      >
        <div class="modal-card-close" @click="close_excel_import_dialog">
          <v-icon>mdi-close</v-icon>
        </div>
      </div>
      
      <v-card>
        <v-card-text class="pt-3">
          <DynamicForm
            ref="dynamicForm"
            :fields="dfields"
            @ready="manage_excel_props($event)"
          />
          <!-- @ready="isReady => enable_dry_run = isReady" -->
          <v-card v-if="showSummary" style="white-space: pre-line;">
            <v-card-text>
                {{ summary }}
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <!-- <v-btn v-if="excel_no_errors"
                class="qmkey-modal-dialog-button-submit"
                @click="importPersist"                
              >
                {{ $vuetify.lang.translator('dialog.send') }}
              </v-btn> -->
              <v-btn v-if="!excel_no_errors"
                class="qmkey-modal-dialog-button-submit"
                @click="getExcelErrorsFile"
              >
                <!-- {{ $vuetify.lang.translator('dialog.send') }} -->
                  Descargar errores
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-card-text>

        <v-card-actions class="qmkey-modal-dialog-card-actions">
          <v-spacer></v-spacer>
          <v-btn 
            :disabled="!enable_dry_run"
            @click="importDryRun"
            class="qmkey-modal-dialog-button-secondary"
          >
            <!-- {{ $vuetify.lang.translator('dialog.clear') }} -->
              Check excel
          </v-btn>
          <v-btn
            class="qmkey-modal-dialog-button-submit"
            @click="importPersist"
            :disabled="(!allow_persist || import_excel_file_changed)"
          >
            <!-- {{ $vuetify.lang.translator('dialog.send') }} -->
              Import
          </v-btn>
        </v-card-actions>
      </v-card>

    </v-dialog>
  </v-container>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'
import ViewTitle from '@/components/ViewTitle'
import customThemes from '@/plugins/themes.js'
import EmpresaImportExport from '@/api/EmpresaImportExport'
import Site from '@/api/Site'
import Roles from '@/api/Roles'
import ModalDialogForm from '@/components/explorer/ModalDialog'
import SearchTextAdmin from '@/components/header/SearchTextAdmin'
import InheritRoles from '@/components/InheritRoles'
import QCentro from '@/api/QCentro';
import SiteCentros from '@/components/SiteCentros';
import ExportSiteActions from '@/views/ExportSiteActions.vue';
import ImportSiteActions from '@/views/ImportSiteActions.vue';
import { downloadFile } from '@/utils/browserfiles';
import { InfoAlert, SuccessAlert, ErrorAlert } from '@/utils/Alerts'
import DynamicForm from '@/components/DynamicForm.vue'

export default {
  name: 'SitesView',
  components: {
    ViewTitle,
    ModalDialogForm,
    SearchTextAdmin,
    InheritRoles,
    SiteCentros,
    ExportSiteActions,
    ImportSiteActions,
    DynamicForm
  },

  data() {
    return {

      currentSite: {},
      message: null,
      fields: [
        {
          text: 'Name',
          align: 'start',
          sortable: true,
          value: 'name',
        },
        {
          text: 'Path',
          sortable: true,
          value: 'path',
        },
        {
          text: 'Parent',
          sortable: true,
          value: 'parent',
        },
        {
          text: '',
          sortable: false,
          value: 'actions',
        },
        {
          value: 'data-table-expand',
          text: '',
          sortable: false,
          filterable: false,
        },
      ],

      storage_types: [
        {
          text: 'FileSystem',
          value: 'filesystem'
        },
        {
          value: 'dropbox',
          text: 'Dropbox'
        },
        {
          value: 'gdrive',
          text: 'GDrive'
        }
      ],
      qmkey_product: (Object.entries(customThemes)
                            .filter(([key, val]) => !!val.name)
                            .map(([key, val]) => ({text: val.name, value: key}))),

      sites_fields_to_collect: [],

      modal_title: '',
      showModalDialog: false,
      fields_to_collect: [],
      submit_button_caption: 'Save', // Harcoded text
      submit_action: function () {},

      tabs: null,
      search:'',

      inherit_roles: [],
      roleFields:[
      {
          text: 'Name',
          align: 'start',
          sortable: true,
          value: 'name',
        },
        {
          text: 'Department',
          sortable: true,
          value: 'department_name',
        },
        {
          text: 'Parent',
          sortable: true,
          value: 'parent_name',
        },
        { value: 'description', text: 'Description', sortable: true },
      ],
      showExcelImportDialog: false,
      dfields: [],
      allow_persist: false,
      summary: '',
      showSummary: false,
      excel_no_errors: false,
      errors_log: {},
      enable_dry_run: false,
      import_excel_file: null,

    }
  },

  computed: {
    ...mapGetters(['sitePath', 'user']),
    ...mapState(['isLoading', 'sites', 'centros']),

    local_sites() {
      return this.sites.filter(item => item.path.startsWith(this.sitePath + '/') || item.path == this.sitePath);
    },

    import_excel_file_changed() {
      // TODO: this is a hack
      // Check if the Excel file changes after running dry run import
      const formdata = this.$refs.dynamicForm.get_data();
      const file = formdata ? formdata.get("file") : {};
      const name = file ? file.name : null;
      if (!this.import_excel_file) {
        return true;
      } else {
        return this.import_excel_file.name != name;
      }
    }
  },

  methods: {
    ...mapActions(['GET_SITES', 'GET_USERS', 'GET_CENTROS']),
    ...mapMutations(['SET_CURRENT_SITE', 'SET_MESSAGE']),
    getLogo(item){
      if (item.logo){
        return item.logo;
      }
    },
    getProcessMap(item){
      if(item.process_map_image){
        return item.process_map_image;
      }
    },
    getBackgroundImage(item){
      if(item.background_image){
        return item.background_image;
      }
    },
    get_fields() {
      let value_name = '';
      let value_storage = this.storage_types[0].value;
      let value_max_users = 1;
      let value_process_map = null;
      let value_logo = null;
      let value_qmkey_product = this.qmkey_product[0].value;
      let value_allow_password_change = false;
      let value_reports_footer_text = '';
      let value_background = null;
      let value_url_name = '';

      if (this.currentSite) {
        value_name = this.currentSite.name
        value_storage = this.currentSite.storage_type
        value_max_users = this.currentSite.max_users_number
        value_qmkey_product = this.currentSite.qmkey_product
        value_allow_password_change = this.currentSite.allow_password_change
        value_reports_footer_text = this.currentSite.reports_footer_text
        value_url_name = this.currentSite.url_name
      }
      return [
        [
          {
            id: 'name',
            label: 'Company name',
            required: true,
            value: value_name,
            readonly: false,
            hidden: null,
            cols: 4,
            class: null,
            component: 'TextInput',
            placeholder: 'Enter company name',
          },
          {
            id: 'url_name',
            label: 'Site url name',
            required: false,
            value: value_url_name,
            readonly: false,
            hidden: null,
            cols: 4,
            class: null,
            component: 'TextInput',
            placeholder: 'Enter Site Url Name',
          },
          {
            id: 'qmkey_product',
            label: 'QMKey product',
            required: true,
            value: value_qmkey_product,
            readonly: false,
            hidden: null,
            cols: 4,
            class: null,
            component: 'Select',
            placeholder: 'Select QMKey product',
            items: this.qmkey_product.map((val) => ([val.value,val.text]))
          },
        ],
        [
          {
            id: 'storage_type',
            label: 'Storage type',
            required: true,
            value: value_storage,
            readonly: false,
            hidden: null,
            cols: 4,
            class: null,
            component: 'Select',
            placeholder: 'Select Storage Type',
            items: this.storage_types.map((val) => ([val.value,val.text])),
          },
          {
            id: 'max_users_number',
            label: 'Max. company users',
            required: true,
            value: value_max_users,
            readonly: false,
            hidden: null,
            cols: 4,
            class: null,
            component: 'NumericInput',
            placeholder: 'Enter Max. Users Number',
            min: 1
          },
        ],
        [
          {
            id: 'process_map_image',
            label: 'Mapa de proceso',
            required: false,
            value: value_process_map,
            readonly: false,
            hidden: null,
            cols: 4,
            class: null,
            component: 'FileInput',
            placeholder: '',
            mimetype: 'image',
          },
          {
            id: 'logo',
            label: 'Logo',
            required: false,
            value: value_logo,
            readonly: false,
            hidden: null,
            cols: 4,
            class: null,
            component: 'FileInput',
            placeholder: '',
          },
          {
            id: 'background_image',
            label: 'Fondo corporativo',
            required: false,
            value: value_background,
            readonly: false,
            hidden: null,
            cols: 4,
            class: null,
            component: 'FileInput',
            placeholder: '',
          }
        ],
        [
          {
            id: 'reports_footer_text',
            label: 'Company reports footer text',
            required: false,
            value: value_reports_footer_text,
            readonly: false,
            hidden: null,
            cols: 8,
            class: null,
            component: 'TextareaInput',
            placeholder: 'Enter company reports footer text',
          }
        ],
        [
          {
            id: 'allow_password_change',
            label: 'Permitir cambio de contraseña',
            required: false,
            value: !!value_allow_password_change,
            readonly: false,
            hidden: null,
            cols: 4,
            class: null,
            component: 'CheckboxInput',
          }
        ],
      ]
    },

    site_centros(site) {
      const res = {};
      for (const centro of Object.values(this.centros)) {
        if (centro.site == site.id) {
          res[centro.id] = centro;
        }
      }
      return res;
     },

    get_centro_fields(item) {
      const c = item !== undefined ? item : {};
      const current_id                = c.id                || '';
      const current_name              = c.name              || '';
      const current_parent            = c.parent            || '';
      const current_url_name          = c.url_name          || '';
      const current_logo              = c.logo              || null;
      const current_background_image  = c.background_image  || null;
      const centros_as_items = ([['none', '--Sin-padre--']]).concat(
        Object.values(this.site_centros(this.currentSite || {}))
              .map(c => [c.id, c.name])
              .sort((a, b) => a[1].localeCompare(b[1])));
     
      return [
        [
          {
            id: 'id',
            label: 'Centro Id',
            required: false,
            value: current_id,
            readonly: true,
            cols: 6,
            class: null,
            component: 'TextInput',
            placeholder: 'Automatic Id',
          },
        ], [
          {
            id: 'name',
            label: 'Centro name',
            required: true,
            value: current_name,
            readonly: false,
            cols: 4,
            class: null,
            component: 'TextInput',
            placeholder: "Centro's name",
          },
          {
            id: 'url_name',
            label: "Centro's URL access name",
            required: false,
            value: current_url_name,
            readonly: false,
            cols: 4,
            class: null,
            component: 'TextInput',
            placeholder: "Centro's URL access name",
          },
          {
            id: 'parent',
            label: "Parent Centro",
            required: true,
            value: current_parent || 'none',
            readonly: false,
            cols: 4,
            class: null,
            component: 'Select',
            placeholder: "Centro's URL access name",
            items: centros_as_items,
            multiple: false,
          },
        ], [
          {
            id: 'process_map_image',
            label: 'Processes map',
            required: false,
            value: this.current_process_map,
            readonly: false,
            cols: 4,
            class: null,
            component: 'FileInput',
            placeholder: '',
            mimetype: 'image',
          },
          {
            id: 'logo',
            label: 'Logo',
            required: false,
            value: current_logo,
            readonly: false,
            cols: 4,
            class: null,
            component: 'FileInput',
            placeholder: '',
          },
          {
            id: 'background_image',
            label: 'Background image',
            required: false,
            value: current_background_image,
            readonly: false,
            cols: 4,
            class: null,
            component: 'FileInput',
            placeholder: '',
          }
        ],
      ];
    },

    getInheritRoles(roles_id){
      return this.inherit_roles.filter(v => roles_id.includes(v.id))
    },

    getAllRoles(){
      this.inherit_roles = [];
      Roles.listAllInheritance(this.sitePath)
          .then((response) => {
            this.inherit_roles = response;
          })
          .catch((err) => {
            console.log(err);
          })      
    },

    addSiteForm() {
      // Default values
      this.currentSite = {
        storage_type: this.storage_types[0].value,
        qmkey_product: this.qmkey_product[0].value,
        max_users_number: 1
      }
      this.modal_title = `Add new company`
      this.fields_to_collect = this.get_fields()
      this.showModalDialog = true
      this.submit_action = this.addSite
      this.submit_button_caption = 'Save'
    },

    addSubSiteForm(item) {
      // Parent id and default values
      this.currentSite = {
        parent: item.id,
        storage_type: this.storage_types[0].value, 
        qmkey_product: this.qmkey_product[0].value,
        max_users_number: 1
      }
      this.modal_title = `Add new sub-company for company #${item.id} ${item.name}`
      this.fields_to_collect = this.get_fields()
      this.showModalDialog = true
      this.submit_action = this.addSite
      this.submit_button_caption = 'Save'    
    },


    deleteSiteForm(item) {
      this.currentSite = item
      this.modal_title = `Delete company #${item.id}-${item.name} `
      this.showModalDialog = true
      this.fields_to_collect = []
      this.submit_action = this.deleteSite
      this.submit_button_caption = 'Delete'
    },

    editSiteForm(item) {
      this.currentSite = item
      this.modal_title = `Edit company #${item.id}`
      this.showModalDialog = true
      this.fields_to_collect = this.get_fields()
      this.submit_action = this.updateSite
      this.submit_button_caption = 'Save'
    },

    addSite(formdata) {
      //this.currentSite.logo = this.logo
      if(this.currentSite.parent) formdata.append('parent', this.currentSite.parent)
      Site.postSite(this.sitePath, formdata)
        .then(() => {
          this.GET_SITES(this.sitePath)
          this.showModalDialog=false
          this.currentSite={}
          this.toggle_dialog()
        })
        .catch(err => {
          this.render_form_errors(err)
        })
    },

    deleteSite() {
      Site.delete(this.sitePath, this.currentSite.id)
        .then(() => {
          this.GET_SITES(this.sitePath)
          this.showModalDialog=false
          this.currentSite={}
          this.toggle_dialog()
        })
        .catch(err => {
          this.render_form_errors(err)
        })
    },

    updateSite(formdata) {
      //If not changed logo or process map, it stays as string, in change, it's a file. Check it's a file to send
      if(typeof(formdata.get('logo'))!="object") formdata.delete('logo')
      if(typeof(formdata.get("process_map_image"))!='object') formdata.delete('process_map_image') 
      if(typeof(formdata.get('background_image'))!='object') formdata.delete('background_image')
      Site.putSite(this.sitePath, this.currentSite.id, formdata)
        .then(() => {
          this.GET_SITES(this.sitePath)
          this.showModalDialog=false
          this.currentSite={}
          this.toggle_dialog()
        })
        .catch(err => {
          this.render_form_errors(err)
        })
    },

    addCentroForm(item) {
      this.currentSite = item
      this.modal_title = `Create a new Centro`
      this.showModalDialog = true
      this.fields_to_collect = this.get_centro_fields()
      this.submit_action = this.addCentro
      this.submit_button_caption = 'Save'
    },
    
    process_form_data(fd) {
       if (fd.get('parent') == 'none') {
         fd.delete('parent');
         fd.set('parent', '');
       }
       return fd;
     },

    update_centeros() {
      this.GET_CENTROS();
    },

     async addCentro(form_data) {
      form_data = this.process_form_data(form_data);
      try {
        this.loading = true;
        await QCentro.post(this.currentSite.id, form_data);
        this.show_modal_dialog = false;
        this.update_centeros();
      } catch (err) {
        console.error("Centros.save_new exception ", err);
      }
      this.loading = false;
    },

    setSearchText(search_text) {
      this.search=search_text;
    },

    toggle_dialog() {
      this.showModalDialog = false;
      this.modalTitle = ``;
      this.fields_to_collect = [];
      this.submit_action = (()=>{});
      this.submit_button_caption = '';
    },

    refreshSites(){
      this.GET_SITES(this.sitePath)
    },

    select_import_site(site) {
      this.modalTitle = ``;
      this.fields_to_collect = [
        [
          {
            id: 'site_id',
            label: "Empresa",
            required: true,
            value: parseInt(((this.sitePath || "").split('/') || []).pop()) || null,
            cols: 4,
            component: 'AutocompleteSelect',
            placeholder: "Site where to import",
            items: this.local_sites.map(site => ([site.id,site.name])),
            multiple: false,
          }, {
            id: 'file',
            label: "File",
            required: true,
            value: null,
            cols: 4,
            component: 'FileInput',
            placeholder: "Import file",
          }
        ]
      ];
      this.submit_action = this.import_site;
      this.showModalDialog = true;
    },

    import_site(formdata) {
      EmpresaImportExport.import(this.sitePath,formdata);
      this.toggle_dialog();
    },

    exportSite(site) {
      EmpresaImportExport.export(site.path,site.id);
    },

    async export_excel(site, formdata) {
      const filename = 'Site_Config_' + site.id + '.xlsx';
      try {
        const data = await EmpresaImportExport.exportExcel(site.path, site.id, formdata);
        downloadFile(data, filename);
      }
      catch (err) {
        console.error(err);
        this.SET_MESSAGE(new ErrorAlert('export-excel.error'));
      }
    },
    async advanced_export_excel(site) {
      this.currentSite = site
      const data = await EmpresaImportExport.getAvailableSheets(site.path);
      this.modalTitle = "Advanced Export Excel";
      this.fields_to_collect = [
        [
          {
            id: 'sheets',
            label: "Sheets",
            required: true,
            value: null,
            cols: 4,
            component: 'AutocompleteSelect',
            placeholder: "Select Sheets for the workbook",
            items: data.map(sheet => ([sheet[0], sheet[1]])),
            multiple: true,
          }
        ],
        [
          {
            id: 'site',
            label: "Site",
            required: true,
            value: site.path,
            cols: 4,
            component: 'TextInput',
            disabled: true,
          }
        ]

      ],
      this.submit_action = this.export_excel_form;
      this.submit_button_caption = 'Export';
      this.showModalDialog = true;
    },

    export_excel_form(formdata) {
      this.submit_button_caption = 'Save'; // reset
      this.export_excel(this.currentSite, formdata)
        .then(() => {
          this.showModalDialog=false
          this.currentSite={}
          this.toggle_dialog()
        })
        .catch(err => {
          this.render_form_errors(err)
        })
    },

    select_import_excel(site) {
      this.modalTitle = ``;
      this.dfields = [
        [
          {
            id: 'file',
            label: "File",
            required: true,
            value: null,
            cols: 4,
            component: 'FileInput',
            placeholder: "Import file",
            readonly: this.import_excel_file_readonly,
          }
        ]
      ];
      // this.submit_action = this.import_site;
      this.showExcelImportDialog = true;
      this.currentSite = site;
    },

    import_site(formdata) {
      EmpresaImportExport.import(this.sitePath,formdata)
      this.toggle_dialog();
    },

    importDryRun() {
      // TODO:
      const formdata = this.$refs.dynamicForm.get_data();
      EmpresaImportExport.importExcelDryRun(this.sitePath,formdata,true)
        .then(data => {
            this.showSummary = true;
            const log_path = "Log Path: " + data.log_folder + "\n\n";
            this.summary = log_path + data.summary;
            this.excel_no_errors = data.log.errors_count == 0;
            this.allow_persist = this.excel_no_errors;
            this.errors_log = data.log.errors;
            this.enable_dry_run = false;
            this.import_excel_file = formdata.get("file");
          })
        .catch(err => {
          this.render_form_errors(err)
        })
    },

    importPersist() {
      const formdata = this.$refs.dynamicForm.get_data();
      EmpresaImportExport.importExcelPersist(this.sitePath, formdata, false)
      .then(data => {
            this.showSummary = true;
            const log_path = "Log Path: " + data.log_folder + "\n\n";
            this.summary = log_path + data.summary;
            this.allow_persist = false;
            this.errors_log = data.log.errors;
            this.enable_dry_run = false;
            this.import_excel_file = formdata.get("file");
            this.SET_MESSAGE(new InfoAlert('export-excel.ok'));
          })
        .catch(err => {
          this.render_form_errors(err);
          this.SET_MESSAGE(new ErrorAlert('import-excel.error'));
        })

    },

    getExcelErrorsFile() {
      const filename = 'Site_Config_' + this.currentSite.id + '_errors.json';
      const data = {
        data: JSON.stringify(this.errors_log, null, 2)
      }
      downloadFile(data ,filename, 'application/json');
    },

    close_excel_import_dialog() {
      this.showExcelImportDialog = false;
      this.currentSite = {};
      this.dfields = [];
      this.reset_excel_import_dialog();
    },

    reset_excel_import_dialog() {
      this.summary = null;
      this.excel_no_errors = null;
      this.errors_log = null;
      this.showSummary = false;
      this.allow_persist = false;
      this.enable_dry_run = false;
      this.import_excel_file = null;
    },

    manage_excel_props(isReady) {
      if (!isReady) {
        this.reset_excel_import_dialog();
      }
      else if (isReady && this.excel_no_errors) {
        this.allow_persist = true;
      }
      else {
        this.allow_persist = false;
        this.enable_dry_run = isReady;
      }
    },
  },

  mounted() {
    this.getAllRoles();
  },
}
</script>


<style lang="scss">
  @import "@/sass/menus.scss";
  @import "@/sass/explorer.scss";
  @import '@/sass/modalform.scss';

</style>
